// extracted by mini-css-extract-plugin
export default {"hint":"TableScrollHint_hint__4v9bu","icon":"TableScrollHint_icon__gvSu9"};